var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilters = function SvgFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.994 5.245 5 3h1l-.006 2.245c1.052.26 1.831 1.245 1.831 2.376 0 1.132-.774 2.117-1.825 2.377V21H5V9.998a2.413 2.413 0 0 1-.006-4.753M4 7.621a1.413 1.413 0 1 1 2.825 0 1.413 1.413 0 0 1-2.825 0M17.994 11.752 18 21h1l-.006-9.21A2.41 2.41 0 0 0 21 9.414c0-1.194-.867-2.22-2.006-2.413L19 3h-1v4c-1.065.25-1.825 1.271-1.825 2.412 0 1.128.774 2.075 1.82 2.34m-.819-2.34a1.413 1.413 0 1 1 2.825 0 1.413 1.413 0 0 1-2.825 0M11.5 10.028V3h1v7.028a2.413 2.413 0 0 1 0 4.721V21h-1v-6.25a2.413 2.413 0 0 1 0-4.722m-.912 2.36a1.413 1.413 0 1 1 2.825 0 1.413 1.413 0 0 1-2.825 0",
    clipRule: "evenodd"
  })));
};
export default SvgFilters;